var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWalletOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_140_77134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_140_77134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 13.5C17.0583 13.5 17.4167 13.3583 17.7 13.075C17.9833 12.7917 18.125 12.4333 18.125 12C18.125 11.5667 17.9833 11.2083 17.7 10.925C17.4167 10.6417 17.0583 10.5 16.625 10.5C16.1917 10.5 15.8333 10.6417 15.55 10.925C15.2667 11.2083 15.125 11.5667 15.125 12C15.125 12.4333 15.2667 12.7917 15.55 13.075C15.8333 13.3583 16.1917 13.5 16.625 13.5ZM5.625 21C5.075 21 4.60417 20.8042 4.2125 20.4125C3.82083 20.0208 3.625 19.55 3.625 19V5C3.625 4.45 3.82083 3.97917 4.2125 3.5875C4.60417 3.19583 5.075 3 5.625 3H19.625C20.175 3 20.6458 3.19583 21.0375 3.5875C21.4292 3.97917 21.625 4.45 21.625 5V7.5H19.625V5H5.625V19H19.625V16.5H21.625V19C21.625 19.55 21.4292 20.0208 21.0375 20.4125C20.6458 20.8042 20.175 21 19.625 21H5.625ZM13.625 17C13.075 17 12.6042 16.8042 12.2125 16.4125C11.8208 16.0208 11.625 15.55 11.625 15V9C11.625 8.45 11.8208 7.97917 12.2125 7.5875C12.6042 7.19583 13.075 7 13.625 7H20.625C21.175 7 21.6458 7.19583 22.0375 7.5875C22.4292 7.97917 22.625 8.45 22.625 9V15C22.625 15.55 22.4292 16.0208 22.0375 16.4125C21.6458 16.8042 21.175 17 20.625 17H13.625Z",
    fill: "#40DF9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletOn);
export default __webpack_public_path__ + "static/media/icon-wallet-on.2638a72ee5b5e238dfd0a0ab4c6de8af.svg";
export { ForwardRef as ReactComponent };